import React, { Component } from 'react'
import DocumentTitle from 'react-document-title'
import { ContainerQuery } from 'react-container-query'
import classNames from 'classnames'
import { enquireScreen, unenquireScreen } from 'enquire-js'
import { loadApp, wrapper } from 'wbap-core-commit'
import { SiderMenu, GlobalHeader } from './components'
import { Layout, Icon, message } from 'antd'
import { Route, Switch } from 'react-router-dom'
import { getMenuData } from './menu'
import { observer, inject } from 'mobx-react'

const {Content, Header} = Layout

const query = {
  'screen-xs': {
    maxWidth: 575,
  },
  'screen-sm': {
    minWidth: 576,
    maxWidth: 767,
  },
  'screen-md': {
    minWidth: 768,
    maxWidth: 991,
  },
  'screen-lg': {
    minWidth: 992,
    maxWidth: 1199,
  },
  'screen-xl': {
    minWidth: 1200,
  },
}

let isMobile

enquireScreen(b => {
  isMobile = b
})

@inject('UIStore')
@observer
@wrapper()
export default class Page extends Component {

  state = {
    isMobile
  }

  componentDidMount () {

  }

  componentWillUnmount () {
    unenquireScreen(this.enquireHandler)
  }

  getPageTitle () {
    let title = 'WBAP'
    return title
  }

  handleMenuCollapse = collapsed => {

  }

  handleNoticeClear = type => {

  }

  handleMenuClick = ({key}) => {

  }

  handleNoticeVisibleChange = visible => {

  }

  render () {
    const {
      collapsed,
      fetchingNotices,
      notices,
      UIStore
    } = this.props
    const layout = (
      <Layout>
        {UIStore.menuDisplay ?
          <SiderMenu
            menuData={getMenuData()}
            collapsed={collapsed}
            isMobile={this.state.isMobile}
            onCollapse={this.handleMenuCollapse}
          /> : null
        }
        <Layout>
          {UIStore.headerDisplay ?
            <Header style={{padding: 0}}>
              <GlobalHeader
                fetchingNotices={fetchingNotices}
                notices={notices}
                collapsed={collapsed}
                isMobile={this.state.isMobile}
                onNoticeClear={this.handleNoticeClear}
                onCollapse={this.handleMenuCollapse}
                onMenuClick={this.handleMenuClick}
                onNoticeVisibleChange={this.handleNoticeVisibleChange}
              />
            </Header> : null
          }
          <Content style={{margin: '24px 24px 0', height: '100vh'}}>
            <Switch>
              <Route exact path='/' render={() => loadApp('wbap-dashboard-dailyPrice')}/>
            </Switch>
          </Content>
        </Layout>
      </Layout>
    )

    return (
      <DocumentTitle title={this.getPageTitle()}>
        <ContainerQuery query={query}>
          {params => <div className={classNames(params)}>{layout}</div>}
        </ContainerQuery>
      </DocumentTitle>
    )
  }
}



// WEBPACK FOOTER //
// ./src/wbap-mian-apps/wbap-admin-main/page.js